import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";

const pathMap = {
	[Locale.cs]: "sluzby" as const,
} satisfies LocalizedString;

export function getServiceAnchor(tenant: Tenant): string {
	return pathMap[tenant.locale];
}
